/**
 * Image URL Utility
 * Constructs full image URLs from relative paths using API_URL base
 */
import { API_URL } from '../constant';

/**
 * Get the base URL for static files from API_URL
 * Removes /api/v1 or /api suffix from API_URL to get the base server URL
 * @returns {string} Base URL for static files
 */
export const getBaseUrl = () => {
    // Remove /api/v1 or /api from the end of API_URL
    return API_URL.replace(/\/api(\/v1)?$/, '');
};

/**
 * Construct full image URL from relative path
 * Handles various edge cases like null, empty, or already full URLs
 * @param {string} path - Relative image path (e.g., /uploads/hotels/image.jpg)
 * @returns {string} Full image URL or empty string if path is invalid
 * 
 * @example
 * // Returns "https://api.travelpradesh.in/uploads/hotels/hotel_1.jpg"
 * getImageUrl('/uploads/hotels/hotel_1.jpg')
 * 
 * @example
 * // Returns already full URL as-is
 * getImageUrl('http://example.com/image.jpg')
 */
export const getImageUrl = (path) => {
    // Handle null, undefined, or empty paths
    if (!path || path === '') {
        return '';
    }

    // If path is already a full URL (http:// or https://), return as-is
    if (path.startsWith('http://') || path.startsWith('https://')) {
        // Extract just the relative path from full URL if it contains /uploads/
        if (path.includes('/uploads/')) {
            const uploadIndex = path.indexOf('/uploads/');
            const relativePath = path.substring(uploadIndex);
            return `${getBaseUrl()}${relativePath}`;
        }
        return path;
    }

    // Ensure path starts with /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    // Construct full URL
    return `${getBaseUrl()}${normalizedPath}`;
};

export default getImageUrl;
